<div class="mobile-content-wrapper">
  <div class="container mt-lg-4 mt-0">
    <div class="font-size-20 mb-1 text-white text-uppercase fw-bold font-heading">
      {{ 'trivia.leaderboard.title' | translate }}
    </div>
    <div class="font-size-14 mb-3 text-white">
      {{ 'trivia.leaderboard.description' | translate }}
    </div>
    <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType" [isMonthlyLeaderboard]="true"></fgb-leaderboard>
  </div>
</div>
